module.exports = __webpack_public_path__ + "themes/fq/img/star@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/star@2x.png
// module id = 67
// module chunks = d-game